import { Link, NavLink } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/authContext";

//import ButtonNavLink from "./ui/ButtonNavLink";

import ImageNav from '../marca_botonera-01.png';
import ImageNavRED from '../logo_RED-01.png';

const NavbarPublic = () => {
    const { user } = useContext(AuthContext);
    const [dark, setDark] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Clases base para los enlaces
    const linkClasses = ({ isActive }) =>
        `px-4 py-2 rounded-md transition-colors duration-200 text-sm font-medium hover:text-white/80 hover:bg-white/20 ${isActive
            ? 'text-white !bg-[#476c97]'
            : 'text-white dark:text-[#476c97]'
        }`;

    // Clases para enlaces en menú móvil
    const mobileLinkClasses = ({ isActive }) =>
        `block w-full px-4 py-3 rounded-md transition-colors duration-200 text-sm font-medium hover:text-white/80 hover:bg-white/20 ${isActive
            ? 'text-white !bg-[#476c97]'
            : 'text-white'
        }`;

    const toggleTheme = () => {
        setDark(!dark);
        document.body.classList.toggle('dark');
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <>
        <nav className="relative w-full grid grid-cols-[1fr_auto_1fr] items-center px-4 transition-colors duration-300">

            {/* COLUMNA IZQUIERDA: Botón hamburguesa (móvil) + Nav links (desktop) */}
            <div className="flex items-center justify-start">
                {/* Botón hamburguesa - Móvil only */}
                <div className="md:hidden flex items-center">
                    <button
                        onClick={toggleMobileMenu}
                        className="p-2 rounded-md text-white hover:bg-white/20 transition-colors"
                        aria-label="Abrir menú"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            {mobileMenuOpen ? (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            ) : (
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            )}
                        </svg>
                    </button>
                </div>

                {/* Enlaces de navegación - Desktop only */}
                <div className="hidden md:flex items-center space-x-4">
                    <NavLink to="/" className={linkClasses}>Inicio</NavLink>
                    <NavLink to="/solicitud-usuario" className={linkClasses}>Solicitud municipio</NavLink>
                    <NavLink to="/solicitud-entidad" className={linkClasses}>Solicitud entidad</NavLink>
                    <NavLink to="/instructivos" className={linkClasses}>Instructivos</NavLink>
                </div>
            </div>

            {/* COLUMNA CENTRO: Logo (duplicado) */}
            <div className="flex items-center justify-end md:justify-center h-full">
                <div className="h-full flex items-center gap-4">
                    {/* Logo 2 - Reemplazar cuando se tenga la segunda imagen */}
                    <img
                        src={ImageNavRED}
                        alt="Logo RED"
                        className="
                        /* Móvil: Altura fija pequeña */
                        h-20
                        /* Desktop: Ancho controlado, altura automática */
                        md:h-auto
                        md:w-full
                        md:max-w-[200px]
                        /* Mantenemos proporción */
                        object-contain
                        "
                    />
                    {/* Logo 1 */}
                    <img
                        src={ImageNav}
                        alt="Logo provincia de Bs As"
                        className="
                        /* Móvil: Altura fija pequeña */
                        h-20
                        /* Desktop: Ancho controlado, altura automática */
                        md:h-auto
                        md:w-full
                        md:max-w-[200px]
                        /* Mantenemos proporción */
                        object-contain
                        "
                    />                    
                </div>
            </div>

            {/* COLUMNA DERECHA: Usuario (desktop) */}
            <div className="hidden md:flex items-center justify-end w-full">
                <div className='flex items-center justify-end gap-3 w-full'>
                    {/* Contenido opcional - o links de autenticación */}
                    <NavLink to="/register" className={linkClasses}>Registro</NavLink>
                    <NavLink to="/login" className={linkClasses}>Acceso usuario</NavLink>
                </div>
            </div>

            {/* Menú móvil desplegable */}
            {mobileMenuOpen && (
                <div className="md:hidden absolute top-full left-0 right-0 z-50 bg-gradient-to-r from-[#e81f76] via-[#417099] to-[#00AEC3] border-t border-white/20 shadow-lg">
                    <div className="px-4 py-2 space-y-1">
                        <NavLink
                            to="/"
                            className={mobileLinkClasses}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            Inicio
                        </NavLink>
                        <NavLink
                            to="/solicitud-usuario"
                            className={mobileLinkClasses}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            Solicitud usuario
                        </NavLink>
                        <NavLink
                            to="/solicitud-entidad"
                            className={mobileLinkClasses}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            Solicitud entidad
                        </NavLink>
                        <NavLink
                            to="/instructivos"
                            className={mobileLinkClasses}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            Instructivos
                        </NavLink>
                        <div className="border-t border-white/20 pt-2 mt-2">
                            <NavLink
                                to="/register"
                                className={mobileLinkClasses}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Registro
                            </NavLink>
                            <NavLink
                                to="/login"
                                className={mobileLinkClasses}
                                onClick={() => setMobileMenuOpen(false)}
                            >
                                Acceso usuario
                            </NavLink>
                        </div>
                    </div>
                </div>
            )}
        </nav>
        </>
    );
};

export default NavbarPublic;

